<template>
  <menu-content-container :border-bottom="false" border-top border-full>
    <t-text-area
      v-model="aiContent"
      data-testid="ai-content-input"
      :label="$t('forms.ai_content_label')"
      :placeholder="$t('forms.ai_content_placeholder')"
      :rows="3"
    ></t-text-area>
  </menu-content-container>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TTextArea } from "@topol/twig-ui";
  import { computed } from "vue";

  const props = withDefaults(
    defineProps<{
      target?: "block" | "section";
    }>(),
    {
      target: "block",
    }
  );

  const mjmlStore = useMjmlStore();

  const aiContent = computed<string>({
    get() {
      if (props.target === "section") {
        return mjmlStore.getSelectedSectionByIndex()?.aiGenerateContent ?? "";
      }
      return mjmlStore.getActiveBlock?.aiGenerateContent ?? "";
    },
    set(value: string) {
      if (props.target === "section") {
        mjmlStore.updateSelectedSectionProp({
          prop: "aiGenerateContent",
          value,
        });
      } else {
        mjmlStore.updateBlockProp({ prop: "aiGenerateContent", value });
      }
    },
  });
</script>
